import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const domo = defineConnector({
  identifier: "domo",
  name: "Domo",
  tagLine: "Business intelligence platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: () => "https://api\\.domo\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create a Domo app",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Domo Developer Portal](https://developer.domo.com/) and navigate to **My Account → New Client** to create a client ID and client secret.",
        },
      ],
    },
    {
      title: "Configure the redirect URI",
      items: [
        {
          kind: "markdown",
          content: "In your app’s settings, add the following redirect URI:",
        },
        {
          kind: "copyable",
          label: "Redirect URI",
          value: "{API_URL}/connected-apps/oauth/domo/callback",
        },
      ],
    },
    {
      title: "Enter your app credentials",
      items: [
        {
          kind: "input",
          label: "Client ID",
          placeholder: "Paste your Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Paste your Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Authorize your Domo account",
      items: [
        {
          kind: "markdown",
          content: "Click below to authorize your Domo account.",
        },
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: () => "https://api.domo.com/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "db",
    scopes: () => ["data", "user"],
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.domo.com/v1/users?limit=1",
  },
});
